// const baseUrl = 'https://xhjh.life-oasis.com/article';
// const baseUrl = 'https://fym.article.life-oasis.com/article';
//const baseUrl = 'http://10.0.0.23:8080';
// const baseUrl = 'http://10.0.0.170:8078';
const baseUrl = 'https://zhjs.article.life-oasis.com/article';
export default baseUrl;